import { render, staticRenderFns } from "./PrepCatalog.vue?vue&type=template&id=94d79cd2&"
import script from "./PrepCatalog.vue?vue&type=script&lang=ts&"
export * from "./PrepCatalog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports